import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { Box } from 'components/ui';
import { useGeolocation } from 'state/geolocation';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { ResetLocationButton } from '../../reset-location-button';

import { IMapButtonsProps } from './types';

/**
 *
 * MapButtons handles logic & UI for the Search This Area
 *  and Reset Location buttons within the map container.
 *
 */
export const MapButtons: FC<React.PropsWithChildren<IMapButtonsProps>> = ({
  onCenterToUserLocation,
  hasPanned,
  isDesktop,
  onPressSearchThisArea,
  searchingNearby,
}) => {
  const { loadingUserCoordinates } = useGeolocation();

  return (
    <Box style={styles.container}>
      <Box
        style={[styles.searchAreaButtonWrapper, !hasPanned && styles.hidden]}
        testID="map-buttons"
      >
        <ActionButton
          size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
          onPress={onPressSearchThisArea}
          testID="search-this-area-button"
          variant={ActionButtonVariants.BOX_SHADOW_INVERSE}
          _pressed={{
            backgroundColor: primitive.$white,
            opacity: 0.9,
            _text: {
              color: primitive.$bbqBrown,
            },
          }}
          _hover={{
            backgroundColor: primitive.$white,
            opacity: 0.9,
            _text: {
              color: primitive.$bbqBrown,
            },
          }}
        >
          {t('searchThisArea')}
        </ActionButton>
      </Box>

      <Box
        style={[styles.resetLocationButtonWrapper, { bottom: isDesktop ? spacing.$2 : spacing.$1 }]}
        testID="reset-location-button-wrapper"
      >
        <ResetLocationButton
          onButtonPress={onCenterToUserLocation}
          loading={searchingNearby || loadingUserCoordinates}
        />
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  hidden: {
    display: 'none',
  },
  resetLocationButtonWrapper: {
    alignSelf: 'flex-end',
    position: 'absolute',
    right: spacing.$2,
  },
  searchAreaButtonWrapper: {
    alignSelf: 'center',
    display: 'flex',
    marginBottom: spacing.$2_5,
    marginHorizontal: spacing.$0,
    marginTop: spacing.$0,
  },
});
